<template lang='pug'>
i.svg-icon.svg-icon-mail
  svg(
    :fill='color'
    :width='`${size}px`'
    :height='`${size}px`'
    viewBox='0 0 100 100'
  )
      path(d='M80.375,20.595H20.703c-4.104,0.015-7.426,3.306-7.422,7.351l-0.037,44.107 c0.012,4.054,3.346,7.339,7.459,7.351h59.672c4.112-0.012,7.447-3.297,7.459-7.351V27.946 C87.822,23.893,84.487,20.607,80.375,20.595z M80.375,72.054H20.703V35.298l29.836,18.377l29.836-18.377V72.054z M50.539,46.324 L20.703,27.946h59.672L50.539,46.324z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>